@if (isPreview()) {
    <div
        class="bazis-gallery-preview"
        [ngClass]="cssClass()"
    >
        <bazis-skeleton [inMedia]="true"></bazis-skeleton>
    </div>
} @else {
    <div
        class="bazis-list bazis-list_gallery"
        [ngClass]="cssClass()"
    >
        <div class="bazis-item">
            <div class="bazis-figure">
                <bazis-skeleton [inMedia]="true"></bazis-skeleton>
            </div>
        </div>
    </div>
}
